import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  updateAdhocInfo, addAdhoc, updateAdhoc, updateStudyList,
  updateMilestoneList, updateRelatedTaskList } from './thunks';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { getMomentDate, getEditRecord, getFormattedDate } from './util';
import * as Icon from 'react-bootstrap-icons';
import setting from './setting';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './AdhocCreate.css';
import FileUpload from './FileUpload';

const AdhocCreateForm = ({ appInfo, userInfo, adhocInfo, startUpdateAdhocInfo,
  startUpdateStudyList, startUpdateMilestoneList, startUpdateRelatedTaskList,
  startAddAdhoc, startUpdateAdhoc }) => {

  const handleClose = () => startUpdateAdhocInfo({ showCreateDialog:false });

  const getUploadUrl = () => `${setting.annotation_server}/adhoc/upload`

  const isFormReadOnly = () => {
    let result = false;
    // console.log('>>> isReadOnly non_bps_can_edit_adhoc_request:', appInfo.non_bps_can_edit_adhoc_request);
    // console.log('>>> userInfo.userId:', userInfo.userId);
    if (appInfo.non_bps_can_edit_adhoc_request && adhocInfo.mode === 'edit') {
      if (userInfo.userId && userInfo.userId.indexOf('bps-') === 0) {
        result = true;
      }
    }
    // console.log('>>> result:', result);
    return result;
  };

  const validateInput = (input) => {
    // check required fields for adhocc request creation
    let validated = true;
    let validationMessages = [];
    console.log('>>> validateInput input:', input);
    if (input['requester_name'] === '') {
      validationMessages.push('Requester Name is needed');
      validated = false;
    }
    if (!validated) {
      alert('Field Validation Message:\n\n' + validationMessages.join('\n'));
    }
    return validated;
  };

  const handleSave = () => {
    console.log('save adhoc record:', adhocInfo.editRecord);
    // validate input (check required fields)
    if (validateInput(adhocInfo.editRecord)) {
      // console.log('>>> adhocInfo.editRecord.request_id:', adhocInfo.editRecord.request_id);
      if (adhocInfo.editRecord.request_id) {
        startUpdateAdhoc(adhocInfo.editRecord);
      } else {
        startAddAdhoc(adhocInfo.editRecord);
      }
      handleClose();
    } else {
      console.log('>>> validation failed');
    }
  };

  const handleCancel = () => {
    console.log('Cancel adhoc record:', adhocInfo.editRecord);
    // let record = getEditRecord();
    // for (var property in record) {
    //   record[property] = '';
    // }
    // startUpdateAdhocInfo({ editRecord:record });
    handleClose();
  };

  const getBpsUsers = () => {
    return _.filter(appInfo.users, user => user.user_type === 'bps_user');
  };

  /*
    "request_id": 15,
    "program": "HB003",
    "study": "301",
    "milestone": "6th Interim Analysis",
    "requester_name": "jwood",
    "request_date": "2021-02-08T00:00:00.000Z",
    "due_date": "2021-03-05T00:00:00.000Z",
    "related_task_id": null,
    "related_task_name": null,
    "urgency_level": "Medium",
    "requester_org": "Medical Writing",
    "description": "",
    "attachment_id": null,
    "image_file_id": null,
    "approve_by": null,
    "programmer": null,
    "programmer_request_date": null,
    "programmer_complete_date": null,
    "complete_date": null,
    "delivery_date": null,
    "request_status": "Approved",
    "request_cancel_date": null,
    "request_cancel_by": null,
    "request_cancel_reason": "",
    "review_status": null,
    "response_lead": null,
    "request_approve_date": null,
    "number_datasets": null,
    "number_tables": null,
    "number_figures": null,
    "number_listings": null,
    "create_date": "2021-02-08T15:55:49.183Z",
    "create_user_id": "jcao",
    "update_date": "2021-02-08T15:55:49.183Z",
    "update_user_id": "jcao",
    "status_date": null,
    "related_program_purpose": null
  */

  const onProgramChange = (data) => {
    console.log('>>> onProgramChange program:', data);
    startUpdateStudyList({ program:data.value });
    startUpdateRelatedTaskList({ program:data.value });
    startUpdateAdhocInfo({ editRecord: getEditRecord({
      program: data.value,
      study: '',
      milestone: '',
      related_task_name: '',
    }, adhocInfo.editRecord)});
  };

  const onStudyChange = (data) => {
    console.log('>>> onStudyChange', data);
    startUpdateMilestoneList({
      program: adhocInfo.editRecord.program,
      study: data.value
    });
    startUpdateRelatedTaskList({
      program: adhocInfo.editRecord.program,
      study: data.value
    });
    startUpdateAdhocInfo({ editRecord: getEditRecord({
      study: data.value,
      milestone: '',
      related_task_name: '',
    }, adhocInfo.editRecord)});
  };

  const onMilestoneChange = (data) => {
    console.log('>>> onMilestoneChange', data);
    startUpdateRelatedTaskList({
      program: adhocInfo.editRecord.program,
      study: adhocInfo.editRecord.study,
      milestone: data.value,
    });
    startUpdateAdhocInfo({ editRecord: getEditRecord({
      milestone: data.value
    }, adhocInfo.editRecord)});
  };

  const onUrgencyLevelChange = (data) => {
    // console.log('>>> onUrgencyLevelChange', data);
    startUpdateAdhocInfo({ editRecord: getEditRecord({
      urgency_level: data.value
    }, adhocInfo.editRecord)});
  };

  const onFieldValueChange = (data) => {
    // console.log('>>> onFieldValueChange:', data);
    let input = {};
    input[data.field] = data.value;
    startUpdateAdhocInfo({ editRecord: getEditRecord(
      input, adhocInfo.editRecord)});
  };

  const onReqResponseTriggerClick = (data) => {
    // console.log('>>> onReqResponseTriggerClick data:', data);
    startUpdateAdhocInfo({ editRecord: getEditRecord({
      showReqResponsePanel: !adhocInfo.editRecord.showReqResponsePanel,
    }, adhocInfo.editRecord)});
  };

  const onFileUpload = (files, mode) => {
    console.log('onFileUpload files:', files, mode);
  };

  // const handleFileImageUpload = (data) => {
  //   console.log('>>> handleFileImageUpload:', data);
  //   // startUpdateAdhocInfo({ editRecord: getEditRecord({
  //   //   requester_org: data.value,
  //   // }, adhocInfo.editRecord)});
  // };

  const handleFileAttachementUpload = (data) => {
    // console.log('>>> handleFileAttachementUpload:', data);
    // startUpdateAdhocInfo({ editRecord: getEditRecord({
    //   requester_org: data.value,
    // }, adhocInfo.editRecord)});
  };

  // SELECT
  // request_id, program, study, milestone, requester_name, request_date, due_date,
  // related_task_id, related_task_name, urgency_level, requester_org, description,
  // attachment_id, image_file_id, approve_by, programmer, programmer_request_date,
  // programmer_complete_date, complete_date, delivery_date, request_status,
  // request_cancel_date, request_cancel_by, request_cancel_reason, review_status,
  // response_lead, request_approve_date, number_datasets,
  // number_tables, number_figures, number_listings, create_date, create_user_id,
  // update_date, update_user_id
  // FROM BPS.dbo.bps_adhoc_request;

  const content = (
    <div>
      <form className="form-adhoc-create">
        <div className="form-row form-row-first">
          <div className="col">
            <label>Program</label>
            <Select placeholder="Select program"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.program,
                value: adhocInfo.editRecord.program
              }}
              options={ (appInfo.programs || []).map((item, index) => (
                { label:item.program, value:item.program }
              )) }
              onChange={ onProgramChange } />
          </div>
          <div className="col">
            <label>Study</label>
            <Select placeholder="Select study"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.study,
                value: adhocInfo.editRecord.study
              }}
              options={ (appInfo.studies || []).map((item, index) => (
                { label:item.study_name, value:item.study_name }
              )) }
              onChange={ onStudyChange } />
          </div>
          <div className="col">
            <label>Milestone</label>
            <Select placeholder="Select milestone"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.milestone,
                value: adhocInfo.editRecord.milestone
              }}
              options={ (appInfo.milestones || []).map((item, index) => (
                { label:item.milestone_name, value:item.milestone_name }
              )) }
              onChange={ onMilestoneChange } />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label>Related Task</label>
            <Select placeholder="Select related task"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.related_task_name,
                value: adhocInfo.editRecord.related_task_name
              }}
              options={ (appInfo.relatedTasks || []).map((item, index) => (
                { label:item.name, value:item.name }
              )) }
              onChange={data => onFieldValueChange({ field:'related_task_name', value:data.value })} />
          </div>
          <div className="col">
            <label>Request Date</label>
            <div>
              <DatePicker
                className="form-control"
                disabled={isFormReadOnly()}
                value={getFormattedDate(adhocInfo.editRecord.request_date)}
                selected={getMomentDate(adhocInfo.editRecord.request_date)}
                dateFormat="MM/dd/yyyy"
                placeholder="request date"
                onChange={date => onFieldValueChange({ field:'request_date', value:date })} />
            </div>
          </div>
          <div className="col">
            <label>Due Date</label>
            <div>
              <DatePicker
                className="form-control"
                disabled={isFormReadOnly()}
                value={getFormattedDate(adhocInfo.editRecord.due_date)}
                selected={getMomentDate(adhocInfo.editRecord.due_date)}
                dateFormat="MM/dd/yyyy"
                placeholder="due date"
                onChange={date => onFieldValueChange({ field:'due_date', value:date })} />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label>Request Title
              <span class="field-required">*</span>
            </label>
            <input type="text" className="form-control"
              disabled={isFormReadOnly()}
              value={adhocInfo.editRecord.request_title}
              onChange={data => onFieldValueChange({
                field:'request_title', value:data.target.value })} />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label>Requester Name
              <span className="field-required">*</span>
            </label>
            <Select placeholder="requester name"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.requester_name,
                value: adhocInfo.editRecord.requester_name,
              }}
              options={ (appInfo.users || []).map((item, index) => (
                { label:item.user_id, value:item.user_id }
              )) }
              onChange={data => onFieldValueChange({ field:'requester_name', value:data.value })} />
          </div>
          <div className="col">
            <label>Requester Organization</label>
            <Select placeholder="requester org"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.requester_org,
                value: adhocInfo.editRecord.requester_org,
              }}
              options={ (adhocInfo.AdhocRequesterOrg || []).map((item, index) => (
                { label:item.code_value, value:item.code_value }
              )) }
              onChange={data => onFieldValueChange({ field:'requester_org', value:data.value })} />
          </div>
          <div className="col">
            <label>Urgency Level</label>
            <Select placeholder="Select urgency level"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.urgency_level,
                value: adhocInfo.editRecord.urgency_level
              }}
              options={ (adhocInfo.AdhocRequestUrgency || []).map((item, index) => (
                { label:item.code_value, value:item.code_value }
              )) }
              onChange={ onUrgencyLevelChange } />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label>Description / Reasons</label>
            <textarea className="form-control"
              disabled={isFormReadOnly()}
              rows={3}
              value={adhocInfo.editRecord.description}
              onChange={data => onFieldValueChange({
                field:'description', value:data.target.value })} />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label>Image (upload)</label>
            <FileUpload accept="*.png" multiple={false}
              disabled={true} fileUploadMode={"image"}
              urlToUpload={getUploadUrl()} onFileUploaded={onFileUpload} />
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <label>Attachement (upload)</label>
            <FileUpload accept="*" multiple={true}
              disabled={isFormReadOnly()} fileUploadMode={"attachment"}
              urlToUpload={getUploadUrl()} onFileUploaded={onFileUpload} />
          </div>
        </div>
        <div className="form-row">
          <div className="requestResponseTrigger" onClick={ onReqResponseTriggerClick }>
            { !adhocInfo.editRecord.showReqResponsePanel &&
            <Icon.CaretRightFill />
            }
            { adhocInfo.editRecord.showReqResponsePanel &&
            <Icon.CaretDownFill />
            }
            <label>Request Response</label>
          </div>
        </div>
        <div className={ "form-row req-response-panel-" + !adhocInfo.editRecord.showReqResponsePanel }>

          <div className="col">
            <label>Request Status</label>
            <Select placeholder="Select request status"
              className="input-field-extra-bottom-padding"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.request_status,
                value: adhocInfo.editRecord.request_status
              }}
              options={ (adhocInfo.AdhocRequestStatus || []).map((item, index) => (
                { label:item.code_value, value:item.code_value }
              )) }
              onChange={data => onFieldValueChange({ field:'request_status', value:data.value })} />

            { adhocInfo.editRecord.request_status &&
              adhocInfo.editRecord.request_status === 'Approved' &&
              <div>
                <label>Response Approved By</label>
                <Select placeholder="Response approved by"
                  className="input-field-extra-bottom-padding"
                  isDisabled={isFormReadOnly()}
                  value={{
                    label: adhocInfo.editRecord.approve_by,
                    value: adhocInfo.editRecord.approve_by,
                  }}
                  options={ (getBpsUsers() || []).map((item, index) => (
                    { label:item.user_id, value:item.user_id }
                  )) }
                  onChange={data => onFieldValueChange({ field:'approve_by', value:data.value })} />
                <label>Request Approved Date</label>
                <div>
                  <DatePicker
                    className="form-control"
                    disabled={isFormReadOnly()}
                    value={getFormattedDate(adhocInfo.editRecord.request_approve_date)}
                    selected={getMomentDate(adhocInfo.editRecord.request_approve_date)}
                    dateFormat="MM/dd/yyyy"
                    placeholder="request approved date"
                    onChange={date => onFieldValueChange({ field:'request_approve_date', value:date })} />
                </div>
              </div>
            }
            { adhocInfo.editRecord.request_status &&
              adhocInfo.editRecord.request_status === 'Completed' &&
              <div>
                <label>Status Date</label>
                <div>
                  <DatePicker
                    className="form-control"
                    disabled={isFormReadOnly()}
                    value={getFormattedDate(adhocInfo.editRecord.statusDate)}
                    selected={getMomentDate(adhocInfo.editRecord.statusDate)}
                    dateFormat="MM/dd/yyyy"
                    placeholder="status date"
                    onChange={date => onFieldValueChange({ field:'statusDate', value:date })} />
                </div>
              </div>
            }
            { adhocInfo.editRecord.request_status &&
              adhocInfo.editRecord.request_status === 'Canceled' &&
              <div>
                <label>Date Request Cancelled</label>
                <div>
                  <DatePicker
                    className="form-control"
                    disabled={isFormReadOnly()}
                    value={getFormattedDate(adhocInfo.editRecord.request_cancel_date)}
                    selected={getMomentDate(adhocInfo.editRecord.request_cancel_date)}
                    dateFormat="MM/dd/yyyy"
                    placeholder="request cancelled date"
                    onChange={date => onFieldValueChange({ field:'request_cancel_date', value:date })} />
                </div>
                <label>Request Cancelled By</label>
                <Select placeholder="Request Cancelled By"
                  className="input-field-extra-bottom-padding"
                  isDisabled={isFormReadOnly()}
                  value={{
                    label: adhocInfo.editRecord.request_cancel_by,
                    value: adhocInfo.editRecord.request_cancel_by,
                  }}
                  options={ (getBpsUsers() || []).map((item, index) => (
                    { label:item.user_id, value:item.user_id }
                  )) }
                  onChange={data => onFieldValueChange({ field:'request_cancel_by', value:data.value })} />
                <label>Reason for cancellation</label>
                <textarea className="form-control"
                  value={adhocInfo.editRecord.cancellationReason}
                  onChange={data => onFieldValueChange({
                    field:'cancellationReason', value:data.target.value })} />
              </div>
            }
          </div>
          <div className="col">
            <label>Response Lead</label>
            <Select placeholder="Response lead"
              className="input-field-extra-bottom-padding"
              isDisabled={isFormReadOnly()}
              value={{
                label: adhocInfo.editRecord.response_lead,
                value: adhocInfo.editRecord.response_lead,
              }}
              options={ (getBpsUsers() || []).map((item, index) => (
                { label:item.user_id, value:item.user_id }
              )) }
              onChange={data => onFieldValueChange({ field:'response_lead', value:data.value })} />

            <label>Programmer</label>
            <Select placeholder="Programmer"
              className="input-field-extra-bottom-padding"
              isDisabled={isFormReadOnly()}
              defaultValue={[]}
              isMulti
              options={ (getBpsUsers() || []).map((item, index) => (
                { label:item.user_id, value:item.user_id }
              )) }
              onChange={data => onFieldValueChange({
                field:'programmer',
                value: _.map(data, (item) => item.value ).join(',')
              })} />
          </div>

          <div className="col">
          </div>
        </div>

        <div className={ "form-row req-response-panel-" + !adhocInfo.editRecord.showReqResponsePanel }>
          <div className="col">
            <label># Datesets</label>
            <input type="text" className="form-control form-control-number-input"
              disabled={isFormReadOnly()}
              value={adhocInfo.editRecord.number_datasets}
              onChange={data => onFieldValueChange({ field:'number_datasets', value:data.target.value })} />
            <label># Tables</label>
            <input type="text" className="form-control form-control-number-input"
              disabled={isFormReadOnly()}
              value={adhocInfo.editRecord.number_tables}
              onChange={data => onFieldValueChange({ field:'number_tables', value:data.target.value })} />
            <label># Figures</label>
            <input type="text" className="form-control form-control-number-input"
              disabled={isFormReadOnly()}
              value={adhocInfo.editRecord.number_figures}
              onChange={data => onFieldValueChange({ field:'number_figures', value:data.target.value })} />
            <label># Listing</label>
            <input type="text" className="form-control form-control-number-input"
              disabled={isFormReadOnly()}
              value={adhocInfo.editRecord.number_listings}
              onChange={data => onFieldValueChange({ field:'number_listings', value:data.target.value })} />
          </div>
          <div className="col">
            <label>Date Programmer Received Request</label>
            <div>
              <DatePicker
                className="form-control"
                disabled={isFormReadOnly()}
                value={getFormattedDate(adhocInfo.editRecord.programmer_request_date)}
                selected={getMomentDate(adhocInfo.editRecord.programmer_request_date)}
                dateFormat="MM/dd/yyyy"
                placeholder="Date Programmer Received Request"
                onChange={date => onFieldValueChange({ field:'programmer_request_date', value:date })} />
            </div>
            <label>Date Programmer Complete</label>
            <div>
              <DatePicker
                className="form-control"
                disabled={isFormReadOnly()}
                value={getFormattedDate(adhocInfo.editRecord.programmer_complete_date)}
                selected={getMomentDate(adhocInfo.editRecord.programmer_complete_date)}
                dateFormat="MM/dd/yyyy"
                placeholder="Date Programmer Complete"
                onChange={date => onFieldValueChange({ field:'programmer_complete_date', value:date })} />
            </div>
            <label>Delivery Date</label>
            <div>
              <DatePicker
                className="form-control"
                disabled={isFormReadOnly()}
                value={getFormattedDate(adhocInfo.editRecord.delivery_date)}
                selected={getMomentDate(adhocInfo.editRecord.delivery_date)}
                dateFormat="MM/dd/yyyy"
                placeholder="Delivery Date"
                onChange={date => onFieldValueChange({ field:'delivery_date', value:date })} />
            </div>
          </div>

          <div className="col">
          </div>
        </div>

        <div className="form-row">
          {isFormReadOnly() ? '' :
            <Button variant="info" className="btn-adhoc btnSave" onClick={handleSave}>Save</Button> }
          <Button variant="info" className="btn-adhoc btnCancel" onClick={handleCancel}>Cancel</Button>
        </div>

      </form>
    </div>
  );
  return content;
};

const mapState = state => ({
  userInfo: state.userInfo,
  adhocInfo: state.adhocInfo,
  appInfo: state.appInfo,
});

const mapDispatch = dispatch => ({
  startAddAdhoc: (data) => dispatch(addAdhoc(data)),
  startUpdateAdhoc: (data) => dispatch(updateAdhoc(data)),
  startUpdateStudyList: (data) => dispatch(updateStudyList(data)),
  startUpdateMilestoneList: (data) => dispatch(updateMilestoneList(data)),
  startUpdateRelatedTaskList: (data) => dispatch(updateRelatedTaskList(data)),
  startUpdateAdhocInfo: (data) => dispatch(updateAdhocInfo(data)),
});

export default connect(mapState, mapDispatch)(AdhocCreateForm);
